/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Faq_1_AInputs */

const en_b2b_faq_1_a = /** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Tier users can connect their existing domains (e.g., yourdealership.com) to our infrastructure. You maintain 100% of your SEO and brand equity while utilizing our high-conversion checkout engine.`)
};

const es_b2b_faq_1_a = /** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los usuarios del plan Sovereign pueden conectar sus dominios existentes a nuestra infraestructura. Mantienes el 100% de tu SEO y capital de marca mientras utilizas nuestro motor de pago de alta conversión.`)
};

const fr_b2b_faq_1_a = /** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les utilisateurs du forfait Sovereign peuvent connecter leurs domaines existants (ex. votreconcession.com) à notre infrastructure. Vous conservez 100 % de votre référencement et de votre capital de marque tout en utilisant notre moteur de paiement à forte conversion.`)
};

const de_b2b_faq_1_a = /** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer des Sovereign-Plans können ihre bestehenden Domains mit unserer Infrastruktur verbinden. Du behältst 100% deines SEOs und Markenwerts.`)
};

const id_b2b_faq_1_a = /** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengguna Paket Sovereign dapat menghubungkan domain mereka yang sudah ada (mis., dealeranda.com) ke infrastruktur kami. Anda mempertahankan 100% SEO dan nilai merek Anda sambil memanfaatkan mesin checkout konversi tinggi kami.`)
};

/** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */
const ja_b2b_faq_1_a = en_b2b_faq_1_a;

/** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */
const zh_b2b_faq_1_a = en_b2b_faq_1_a;

/** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */
const ar_b2b_faq_1_a = en_b2b_faq_1_a;

/** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */
const it_b2b_faq_1_a = en_b2b_faq_1_a;

/** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */
const ru_b2b_faq_1_a = en_b2b_faq_1_a;

/** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */
const pt_b2b_faq_1_a = en_b2b_faq_1_a;

/** @type {(inputs: B2b_Faq_1_AInputs) => LocalizedString} */
const ko_b2b_faq_1_a = en_b2b_faq_1_a;

/**
* | output |
* | --- |
* | "Sovereign Tier users can connect their existing domains (e.g., yourdealership.com) to our infrastructure. You maintain 100% of your SEO and brand equity whil..." |
*
* @param {B2b_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_faq_1_a = /** @type {((inputs?: B2b_Faq_1_AInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Faq_1_AInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_faq_1_a(inputs)
	if (locale === "es") return es_b2b_faq_1_a(inputs)
	if (locale === "fr") return fr_b2b_faq_1_a(inputs)
	if (locale === "de") return de_b2b_faq_1_a(inputs)
	if (locale === "ja") return ja_b2b_faq_1_a(inputs)
	if (locale === "zh") return zh_b2b_faq_1_a(inputs)
	if (locale === "ar") return ar_b2b_faq_1_a(inputs)
	if (locale === "id") return id_b2b_faq_1_a(inputs)
	if (locale === "it") return it_b2b_faq_1_a(inputs)
	if (locale === "ru") return ru_b2b_faq_1_a(inputs)
	if (locale === "pt") return pt_b2b_faq_1_a(inputs)
	return ko_b2b_faq_1_a(inputs)
});